import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-video-element',
  templateUrl: './video-element.component.html',
  styleUrls: ['./video-element.component.css']
})
export class VideoElementComponent implements OnInit {

  @Input() video;
  @Input() id;
  @Output() deleteAction = new EventEmitter();
  @Output() editAction = new EventEmitter();
  @Output()  updateAction = new EventEmitter();
  type:boolean = true;

  constructor() { }

  ngOnInit() {
    this.checkType();
  }

  edit(id, url, title, description, videoType, catId) {
    
    let obj = {
      id:id,
      url:url,
      title:title,
      description:description,
      videoType:videoType,
      catId:catId
    }
    this.editAction.emit(obj);
  }

  delete(id) {
    this.deleteAction.emit(id);
  }

  update(){
    this.updateAction.emit();
  }

  checkType() {
  
    this.type = this.id == "ha" ? false : true;
  }


}
